<template>
  <el-dialog width="600px" title="批量新建订单售后" v-model="isvisible">
    <el-form
      ref="saleFormRef"
      :model="saleForm"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="售后类型" prop="saletype">
        <el-select v-model="saleForm.saletype" placeholder="售后类型" style="width:100%">
          <el-option label="退货" :value="1" />
          <el-option label="换货" :value="2" />
          <el-option label="安比例赔付" :value="3" />
          <el-option label="仅退款未发货" :value="4" />
          <el-option label="其他" :value="5" />
        </el-select>
      </el-form-item>

      <el-form-item label="售后说明" prop="salenote">
        <el-input
          type="textarea"
          autosize
          v-model.trim="saleForm.salenote"
          placeholder="请输入售后说明"
        />
      </el-form-item>
      <el-form-item label="售后状态" prop="salestatus">
        <el-select v-model="saleForm.salestatus" placeholder="售后状态" style="width:100%">
          <el-option label="未完成" :value="1" />
          <el-option label="已完成" :value="2" />
          <el-option label="已作废" :value="3" />
        </el-select>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="doAddSale" :loading="loading" >{{
          loading ? "提交中 ..." : "确认"
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
  <script setup>
import { ref, defineExpose, defineEmits } from "vue";
import { ElMessage } from "element-plus";
import { batchAddOrderSales } from "@/api/order/sale";

let timer;

const loading = ref(false);

const emit = defineEmits(["click"]); // 声明父触发事件

const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const saleFormRef = ref();
const saleForm = ref({
  orderid: "",
  goodsid:"",
  saletype: "",
  salenote: "",
  salestatus: "",
  oldsaleamount: "",
  oldcostamount: "",
});
const orderSaleMethod = (saleObj) => {
  saleForm.value = {
    orderid: saleObj.orderid,
    goodsid: saleObj.goodsid,
    oldsaleamount: saleObj.oldsaleamount,
    oldcostamount: saleObj.oldcostamount,
  };
  console.log("saleForm.value1111---", saleForm.value);
};

defineExpose({ changeVisible, orderSaleMethod });

const doAddSale = () => {
  saleFormRef.value.validate((valid) => {
    if (!valid) {
      ElMessage("请先完善表单数据填写！");
      return;
    }

    let orders = [];
    let orderids = saleForm.value.orderid;
    let goodsids = saleForm.value.goodsid;
    let oldsaleamounts = saleForm.value.oldsaleamount
    let oldcostamounts = saleForm.value.oldcostamount

    for (let i = 0; i < orderids.length; i++) {
      orders.push({
        orderid: orderids[i],
        goodsid: goodsids[i],
        saletype: saleForm.value.saletype,
        salenote: saleForm.value.salenote,
        salestatus: saleForm.value.salestatus,
        oldsaleamount: oldsaleamounts[i],
        oldcostamount: oldcostamounts[i],
      });
    }
    // console.log("orders is---", orders);

    batchAddOrderSales(orders).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          closeDialog();
          emit("click");
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

const closeDialog = () => {
  isvisible.value = false;
  saleFormRef.value.resetFields();
  clearTimeout(timer);
};
//表单验证规则
const rules = ref({
  saletype: [
    {
      required: true,
      message: "请选择售后类型",
      trigger: "change",
    }
  ],
  salenote: [
    {
      required: true,
      message: "请输入售后说明",
      trigger: "blur",
    },
    {
      min: 2,
      max: 200,
      message: "售后说明长度2到200",
      trigger: "blur",
    },
  ],
  salestatus: [
    {
      required: true,
      message: "请选择售后状态",
      trigger: "change",
    },
  ],
});
</script>
  <style scoped>
.el-dialog {
  text-align: left;
}
.el-dialog__body {
  padding-top: 15px;
}
</style>